import dataBase from '@/dataBase/database'
import { reportService } from '@/_services'
import { fileService } from './file.service'
import { motivationalReportService } from './motivationalReport.service'
class SyncManager {
  constructor() {
    this.isSyncing = false
    this._store = null
    this._initialized = false
  }

  init(store) {
    if(this._initialized) return
    this._initialized = true
    this._store = store
    window.addEventListener('offline', () => {
      this._store.commit('pointreport/setIsOnline', false)
    })
    window.addEventListener('online', () => {
      this._store.commit('pointreport/setIsOnline', true)
      this.syncAll()
    })
  }

  async syncAll() {
    if (!navigator.onLine) {
      window.alert('Нет подключения к интернету')
      return
    }

    if (this.isSyncing) return
    this.isSyncing = true
    this._store.commit('pointreport/setLoadingAsync', true)
    try {
      let unsyncedReportData = await dataBase.productReportData.where('synced').equals(0).count()
      let unsyncedPointReports = await dataBase.pointReport.where('synced').equals(0).count()
      let unsyncedMotivationalDmpReport = await dataBase.motivationalDmpReport.where('synced').equals(0).count()
      let unsyncedMotivationalDmp = await dataBase.motivationalDmp.where('synced').equals(0).count()

      if (unsyncedReportData === 0 && unsyncedPointReports === 0 && unsyncedMotivationalDmpReport === 0 && unsyncedMotivationalDmp === 0) return

      await this._syncReportData()
      await this._syncPointReports()
      await this._syncDmpReports()
      await this._syncMotivationalDmp()

    } catch (err) {
      console.error('[SyncManager]', err)
    } finally {
      this.isSyncing = false
      this._store.commit('pointreport/setLoadingAsync', false)
    }
  }

  async _syncReportData() {
    let unsynced = await dataBase.productReportData.where('synced').equals(0).toArray()

    for (let item of unsynced) {
      try {
        let uploadedPhotos = await this._uploadPhotos(item.id, 'product')
        await reportService.sendReportData({
          projectId:      item.projectId,
          tradePointId:   item.pointId,
          productId:      item.productId,
          reportItemInfo: item.data,
          comment:        item.data.comment,
          presense:       item.data.presense,
          photos:         uploadedPhotos,
        })

        await dataBase.productReportData.update(item.id, { synced: 1 })
      } catch (err) {
        console.error(`[SyncManager] Ошибка reportData ${item.id}:`, err)
      }
    }
  }

  async _syncPointReports() {
    let unsynced = await dataBase.pointReport.where('synced').equals(0).toArray()

    for (let item of unsynced) {
      try {
        let uploadedPhotos = await this._uploadPhotos(String(item.pointId))
        await reportService.sendPreReport({
          projectId:    item.projectId,
          tradePointId: item.pointId,
          comment:      item.comment,
          tempPhotos:   uploadedPhotos,
          reportPhoto: item.reportPhoto
        })

        await dataBase.pointReport.update(item.id, { synced: 1 })
      } catch (err) {
        console.error(`[SyncManager] Ошибка pointReport ${item.id}:`, err)
      }
    }
  }

  async _syncMotivationalDmp() {
    const unsynced = await dataBase.motivationalDmp.where('synced').equals(0).toArray()

    for(const dmp of unsynced) {
      try {
        let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, dmp.motivationalReportId)
        await dataBase.motivationalDmp.update(dmp.id, { serverId: data.id, synced: 1 })
      } catch (error) {
        console.error(`[SyncManager] Ошибка motivationalDmp ${dmp.id}:`, error)
      }
    }
  }

  async _syncDmpReports() {
    const unsynced = await dataBase.motivationalDmpReport.where('synced').equals(0).toArray()

    for (const report of unsynced) {
      try {
        let serverDmpId
        const dmp = await dataBase.motivationalDmp.get(Number(report.localDmpId))
        if (dmp.serverId) {
          serverDmpId = dmp.serverId
        } else {
          let data = await motivationalReportService.createDmp({ id: dmp.serverId, dmpCategory: dmp.dmpCategory, comment: dmp.comment }, dmp.motivationalReportId)
          serverDmpId = data.id
          await dataBase.motivationalDmp.update(dmp.id, { serverId: serverDmpId, synced: 1 })
        }

        const uploadedPhotos = await this._uploadPhotos(`${dmp.motivationalReportId}_${dmp.id}`)
        await motivationalReportService.sendReportDmp(serverDmpId, {dmpCategory: report.dmpCategory, reportPhoto: uploadedPhotos})

        await dataBase.motivationalDmpReport.update(report.id, { synced: 1 })

      } catch (err) {
        console.error(`[SyncManager] Ошибка motivationalDmpReport ${report.id}:`, err)
      }
    }
  }

  async _uploadPhotos(reportId) {
    let photos = await dataBase.photos.where('reportId').equals(String(reportId)).filter(p => p.synced === 0).toArray()
    let uploaded = []

    for (let photo of photos) {
      try {
        let formData = new FormData()
        formData.append('files[]', photo.blob, photo.fileName)

        let data = await fileService.uploadFiles(formData, photo.motivational ? true : false, photo.dmp && photo.motivational ? true : false, () => {})
        data.forEach(x => x.dmp = photo.dmp)

        await dataBase.photos.update(photo.id, { offline: false, synced: 1 })
        uploaded.push(...data)
      } catch (err) {
        console.error(`[SyncManager] Ошибка загрузки фото ${photo.id}:`, err)
      }
    }

    return uploaded
  }
}

export default new SyncManager()